import React from 'react';
import { connect } from 'react-redux';
import classes from './TagsTree.module.scss';
import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';
import * as actions from 'store/actions/index';

import Input from 'Flow2/components/UI/Input/Input';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

const MIN_INPUT_LENGTH = 2;

const SingleTag = (props) => {
    let handleClick = () => {
        props.handleTagClick(props);
    }

    return (
        <div className={[props.class, 'pointer'].join(' ')} onClick={handleClick}>
            {props.tag.description}
        </div>
    )
}

class TagsTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTags: [],
            foundTags: { tags: [], modelsIds: [] },
            value: "",
            json: (props.data === 'tags' && this.props.apiTags) || this.props.apiModels,
            lang: props.lang.toUpperCase(),
            defaultLanguage: this.props.defaultLanguage || "EN",
            preSelectedTags: props.preSelectedTags
        };

        if (props.preSelectedTags) {
            this.state.selectedTags = TagsTree.initSelectedTags(props, this.state);
        }
    };

    handleClearInput = id => {
        this.setState({ foundTags: { tags: [], modelsIds: [] }, value: "" });
    };

    onKeyUp = (evt) => {
        let foundTags = {};
        foundTags.tags = [];
        foundTags.modelsIds = []; // Here come the id's of the first level

        let inputValue = evt.target.value;

        if (inputValue.length >= MIN_INPUT_LENGTH) {
            for (let levels1 of this.state.json.Levels) {
                if (levels1.Levels && levels1.Levels.length) {
                    for (let levels2 of levels1.Levels) {
                        if (levels2.Levels) {
                            for (let tag of levels2.Levels) {
                                let language = this.state.lang || this.props.language;
                                if (!tag[language]) {
                                    language = this.state.defaultLanguage;
                                }

                                // check HideLevel == because value could be int or string
                                if (tag[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (tag.HideLevel === 'undefined' || parseInt(tag.HideLevel) === 0)) {
                                    foundTags.tags.push({ 'id': tag.ID, 'description': tag[language], levels: [levels1[language], levels2[language]] });
                                }
                            }
                        } else {
                            let language = this.state.lang || this.props.language;
                            if (!levels2[language]) {
                                language = this.state.defaultLanguage;
                            }

                            // check HideLevel == because value could be int or string
                            if (levels2[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels2.HideLevel === 'undefined' || levels2.HideLevel == 0)) {
                                if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                    foundTags.modelsIds.push(levels1.ID);
                                    foundTags.tags.push({ 'id': levels1.ID, 'description': levels1[language] });
                                }

                                foundTags.tags.push({ 'id': levels2.ID, 'description': levels2[language], levels: [levels1[language]] });
                            } else {
                                if (levels1[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels1.HideLevel === 'undefined' || levels1.HideLevel == 0)) {
                                    if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                        foundTags.modelsIds.push(levels1.ID);
                                        foundTags.tags.push({ 'id': levels1.ID, 'description': levels1[language] });
                                    }
                                }
                            }
                        }
                    }
                } else {
                    let language = this.state.lang || this.props.language;
                    if (!levels1[language]) {
                        language = this.state.defaultLanguage;
                    }

                    if (levels1[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels1.HideLevel === 'undefined' || levels1.HideLevel == 0)) {
                        if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                            foundTags.modelsIds.push(levels1.ID);
                            foundTags.tags.push({ 'id': levels1.ID, 'description': levels1[language] });
                        }
                    }
                }
            }
        }

        this.setState({ foundTags: foundTags, value: evt.target.value });
    };

    initSelectedTags = (props) => {
        for (let levels1 of this.state.json.Levels) {
            if (levels1.Levels && levels1.Levels.length) {
                for (let levels2 of levels1.Levels) {
                    if (levels2.Levels) {
                        for (let tag of levels2.Levels) {
                            if (props.preSelectedTags.includes(tag.ID + "")) {
                                this.state.selectedTags.push({ 'id': tag.ID, 'description': tag[this.state.lang || props.language], levels: [levels1[this.state.lang || props.language], levels2[this.state.lang || props.language]] });
                            }
                        }
                    } else {
                        if (props.preSelectedTags.includes(levels2.ID + "")) {
                            this.state.selectedTags.push({ 'id': levels2.ID, 'description': levels2[this.state.lang || props.language], levels: [levels1[this.state.lang || props.language]] });
                        }
                    }
                }
            } else {
                if (props.preSelectedTags.includes(levels1.ID + "")) {
                    this.state.selectedTags.push({ 'id': levels1.ID, 'description': levels1[this.state.lang || props.language] });
                }
            }
        }

        // save pre selected tags because parent component will receive selected tag data from the store
        // also save empty array of pre selected tags because otherwise the store will not reset

        if (props.data === 'tags') {
            props.saveSelectedTags(this.state.selectedTags);
        }

        if (props.data === 'models') {
            props.saveSelectedModels(this.state.selectedTags);
        }
    }

    static initSelectedTags(props, state) {
        const selectedTags = [];

        for (let levels1 of state.json.Levels) {
            if (levels1.Levels && levels1.Levels.length) {
                for (let levels2 of levels1.Levels) {
                    if (levels2.Levels) {
                        for (let tag of levels2.Levels) {
                            if (props.preSelectedTags.includes(tag.ID + "")) {
                                selectedTags.push({ 'id': tag.ID, 'description': tag[state.lang || props.language], levels: [levels1[state.lang || props.language], levels2[state.lang || props.language]] });
                            }
                        }
                    } else {
                        if (props.preSelectedTags.includes(levels2.ID + "")) {
                            selectedTags.push({ 'id': levels2.ID, 'description': levels2[state.lang || props.language], levels: [levels1[state.lang || props.language]] });
                        }
                    }
                }
            } else {
                if (props.preSelectedTags.includes(levels1.ID + "")) {
                    selectedTags.push({ 'id': levels1.ID, 'description': levels1[state.lang || props.language] });
                }
            }
        }

        // save pre selected tags because parent component will receive selected tag data from the store
        // also save empty array of pre selected tags because otherwise the store will not reset

        if (props.data === 'tags') {
            props.saveSelectedTags(selectedTags);
        }

        if (props.data === 'models') {
            props.saveSelectedModels(selectedTags);
        }

        return selectedTags;
    }

    handleTagClick = (props) => {
        let selectedTags = this.state.selectedTags.slice();
        let tagExists = false;

        for (let tag of selectedTags) {
            if (tag.id === props.tag.id) {
                tagExists = true;
            }
        }

        if (!tagExists) {
            selectedTags.push(props.tag);
        }

        this.setState({ selectedTags: selectedTags });

        if (this.props.data === 'tags') {
            this.props.saveSelectedTags(selectedTags);
        }

        if (this.props.data === 'models') {
            this.props.saveSelectedModels(selectedTags);
        }
    };

    handleRemoveTag = (tagId) => {
        let selectedTags = this.state.selectedTags.slice();

        selectedTags = selectedTags.filter(tag => {
            return tag.id !== tagId;
        });

        this.setState({ selectedTags: selectedTags });
        if (this.props.data === 'tags') {
            this.props.saveSelectedTags(selectedTags);
        }

        if (this.props.data === 'models') {
            this.props.saveSelectedModels(selectedTags);
        }
    };

    render = () => {
        console.log(this.state);
        if (this.props.readonly) {
            return this.state.selectedTags.map(tag => {
                return (<span key={'seld_' + tag.id}>{tag.description + ";"}&nbsp;</span>);
            });
        }

        return (
            <div className="">
                <FlexRow className="relative">
                    <Input
                        value={this.state.value}
                        elementConfig={{ type: 'text', id: 'tagsInput' }}
                        changed={this.onKeyUp} />
                    {<img alt="" className={[classes.clear, 'pointer'].join(' ')} onClick={() => { this.handleClearInput('tagsInput') }} src={iconDelete} />}
                </FlexRow>

                <FlexRow className={classes.wrap}>
                    {
                        this.state.selectedTags.map(tag => {
                            return (
                                <div key={'seld_' + tag.id} className={[classes.selectedTags, 'flex_container', 'relative'].join(' ')} >
                                    <span className="text_ellipsis" title={tag.levels && tag.levels.join('->') + '->' + tag.description || tag.description} >{tag.description}</span>
                                    <img alt="" className="pointer" onClick={() => { this.handleRemoveTag(tag.id) }} src={iconDelete} />
                                </div>
                            )
                        })
                    }

                </FlexRow>
                <FlexColumn>
                    {
                        this.state.foundTags.tags.map(tag => {
                            return (<SingleTag class={this.state.foundTags.modelsIds.indexOf(tag.id) !== -1 && classes.tagGroup || classes.tag} key={tag.id} handleTagClick={this.handleTagClick} tag={tag} />)
                        })
                    }
                </FlexColumn>
            </div>
        )
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        console.log("getDerivedStateFromProps");
        /*let selectedTags = prevState.selectedTags || [];
        
        if(nextProps && prevState && nextProps.preSelectedTags && (nextProps.preSelectedTags !== prevState.preSelectedTags)) {
            selectedTags = TagsTree.initSelectedTags(nextProps, prevState);
        }*/

        return {
            /*selectedTags: selectedTags,
            preSelectedTags: nextProps.preSelectedTags,*/
            lang: nextProps.lang.toUpperCase()
        }
    }

    static getSelectedTags(data, props) {
        data = data || "";
        if ((data !== undefined) && (data !== "") && (data.length > 0)) {
            let selectedTags = [];
            data.map((item) => { selectedTags.push(item[props]); });
            return selectedTags.join(';');
        }
        return "";
    }
}

const mapStateToProps = (state) => {
    return {
        selectedTags: state.ui.selectedTags,
        apiTags: state.ui.apiTags,
        apiModels: state.ui.apiModels,
        language: state.ui.language.toUpperCase()
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveSelectedTags: (selectedTags) => dispatch(actions.saveSelectedTags(selectedTags)),
        saveSelectedModels: (selectedModels) => dispatch(actions.saveSelectedModels(selectedModels)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsTree);

